import { Documents } from '@features/ForestOwner/Search/Overview/Documents/Documents'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/forestowner/$forestownerId/documents')({
  component: RouteComponent,
  staticData: {
    breadcrumb: 'Dokumenter',
  },
})

function RouteComponent() {
  const { forestownerId } = Route.useParams()
  return <Documents forestownerId={forestownerId} />
}
